import DefaultMapper, { addCustomMethods } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class UserMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'user/users';
	}

	prepareUpdate({ type, resource, params, options, mappedResource }) {
		super.prepareUpdate(...arguments);
		options.url = `${API_BASE_PATH_ADMIN}/user/users/${params.id}/userdata`;
		options.body = JSON.stringify({
			newEmailAddress: params.data.primaryEmail,
			oldEmailAddress: params.previousData.primaryEmail,
			newPhoneNumber: params.data.primaryPhoneNumber,
			oldPhoneNumber: params.previousData.primaryPhoneNumber,
			firstName: params.data.firstName,
			lastName: params.data.lastName,
			gender: params.data.gender,
			dateOfBirth: params.data.dateOfBirth,
			countryOfBirth: params.data.birthCountry,
			placeOfBirth: params.data.birthPlace,
			personalNumber: params.data.personalNumber,
			citizenship: params.data.citizenship,
			country: params.data.nationCode,
			language: params.data.language,
			occupation: params.data.occupation,
			sourceOfIncome: params.data.sourceOfIncome
		});
	}

	finishUpdate({ type, resource, params, options, mappedResource, result }) {
		return {
			data: {
				id: params.data.id,
				...result.data
			}
		};
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}${addCustomMethods(params)}`;
		options.method = 'POST';
		options.body = JSON.stringify(params.data);
	}

	finishCreate({ type, resource, params, options, mappedResource, result }) {
		if (params.method === 'removeFromWatchList' || params.method === 'addToWatchList') {
			// These methods don't return a result, so we'll simply return the incoming data;
			// the action needs to dispatch a refreshView to fetch the updated user!
			return { data: params.data };
		} else {
			return super.finishCreate({ type, resource, params, options, mappedResource, result });
		}
	}

	mapResult({ type, resource, params, options, mappedResource, result }) {
		if (result !== undefined) {
			return result.data;
		} else {
			return '';
		}
	}
}

export default UserMapper;
